__turbopack_context__.v({
  "discountWrapperp": "wP4UMW_discountWrapperp",
  "discountedFullPrice": "wP4UMW_discountedFullPrice",
  "price": "wP4UMW_price",
});
